import { computed, watch, } from 'vue'
import { getActivePinia, storeToRefs, } from 'pinia'
import { useResourceListStore, } from '@/assets/js/src/modules/resource/_pinia/resourceList'
import { mapUserOptionByPath, } from '@/assets/js/src/modules/user/_pinia/mapUserOptionByPath'
import { ERROR, LOADED, LOADING, UPDATING, } from '@/assets/js/src/util/composables/usePrefetchData'
import { DIR_LTR, DIR_RTL, } from '@/assets/js/src/modules/lang/_pinia/lang'

export function useGraphicListFilter () {
    let resourceListStore = useResourceListStore(getActivePinia())
    let { books, } = storeToRefs(resourceListStore)
    
    // FILTER
    watch(books,()=>resourceListStore.reload = true)
    
    // SORT
    const sort = computed(mapUserOptionByPath('resource/graphic/sort'))
    watch(sort,()=>resourceListStore.reload = true)
    
    return {
        books,
        sort,
        LOADED,
        LOADING,
        UPDATING,
        ERROR,
        DIR_RTL,
        DIR_LTR,
    }
}
